import ChevronDownIcon from '@assets/icons/chevron-down.svg';
import LockIcon from '@assets/icons/lock.svg';
import React, { useState } from 'react';
import { OrderGuideCollectionsActionSheet } from './order-guide-collections-action-sheet';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useNewOrderContext } from '@/contexts/new-order-context';
import { useOrderGuideItemsContext } from '@/contexts/order-guide-items-context';
import { useOrderGuideSettingsContext } from '@/contexts/order-guide-settings-context';
import { useSmallLayoutSizeValue } from '@/contexts/layout-context';
import { useTheme } from '@/contexts/theme-context';

const TITLE_HIT_SLOP = {
  bottom: 0,
  left: 16,
  right: 0,
  top: 0,
};

export const MultiOrderGuideTitle: React.FC = () => {
  const theme = useTheme();
  const { customOrderGuideEditingEnabled } = useNewOrderContext();
  const { setSelectedCollectionUUID, selectedCollectionUUID } =
    useOrderGuideSettingsContext();
  const { selectedCollection } = useOrderGuideItemsContext();

  const [showListActionSheet, setShowListActionSheet] = useState(false);

  const titleStyle = useSmallLayoutSizeValue(
    TYPOGRAPHY.navigationTitle,
    TYPOGRAPHY.navigationTitleLarge,
  );

  const lockIconSize = useSmallLayoutSizeValue(
    { height: 15, width: 12 },
    { height: 20, width: 16 },
  );

  if (!selectedCollection) {
    return null;
  }

  return (
    <>
      <TouchableOpacity
        hitSlop={TITLE_HIT_SLOP}
        onPress={() => setShowListActionSheet(true)}
        style={styles.touchable}
      >
        <View style={styles.titleContainer}>
          <Text numberOfLines={1} style={titleStyle}>
            {selectedCollection.name}
          </Text>
          {selectedCollection.isLocked ? (
            <LockIcon {...lockIconSize} stroke={theme.sk.color.icon.tertiary} />
          ) : null}
        </View>
        <ChevronDownIcon fill={theme.colors.primary} height={7} width={14} />
      </TouchableOpacity>
      {showListActionSheet && selectedCollectionUUID ? (
        <OrderGuideCollectionsActionSheet
          canEditCollections={customOrderGuideEditingEnabled}
          onClose={() => setShowListActionSheet(false)}
          onSelect={(value) => {
            setSelectedCollectionUUID(value);
            setShowListActionSheet(false);
          }}
          selectedCollectionUUID={selectedCollectionUUID}
        />
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  titleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    flexShrink: 1,
    gap: 8,
    marginRight: 16,
  },
  touchable: {
    alignItems: 'center',
    flexDirection: 'row',
    flexShrink: 1,
    paddingRight: 16,
  },
});
